export default __webpack_public_path__ + "static/media/flag-laos.2aa72319.svg";